import { render, staticRenderFns } from "./by_channelPacket.vue?vue&type=template&id=96230312&scoped=true"
import script from "./by_channelPacket.vue?vue&type=script&lang=js"
export * from "./by_channelPacket.vue?vue&type=script&lang=js"
import style0 from "./by_channelPacket.vue?vue&type=style&index=0&id=96230312&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96230312",
  null
  
)

export default component.exports